const DATA_HOOKS = {
  HIGHLIGHTED_BOX: 'highlighted-box',
};

export { DATA_HOOKS };
